import "reflect-metadata";
import ReactDOM from 'react-dom/client';
import './index.css';
import EntryComponent from './App';
import reportWebVitals from './reportWebVitals';
import { Provider } from 'inversify-react';
import container from "./lib/di/container";
import { registerLicense } from '@syncfusion/ej2-base';

// Registering Syncfusion license key
registerLicense('ORg4AjUWIQA/Gnt2UlhhQlVMfV5AQmBIYVp/TGpJfl96cVxMZVVBJAtUQF1hTX9Rd0ViWHpadXFXRGBa');

// Define new conditioned console
if (process.env.REACT_APP_IS_DEBUG === "false") {
  window.console.log = function(){};
}

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  
  <Provider container={container}>
    <EntryComponent></EntryComponent>
  </Provider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
